import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DoorSlidingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"door_sliding"}/>
}
